import GooglePayWrapper from './components/GooglePayWrapper';


export {GooglePayWrapper};
